export default {
  state: {
    isShopSidebarCollapse: false,
    isProductSidebarCollapse: false,
    isServiceSidebarCollapse: false,
    isUserSidebarCollapse: false,
    isSettingsSidebarCollapse: false,
    isNtaxUserSidebarCollapse: false,
    isStockTakingSidebarCollapse: false,
    isDocketSidebarCollapse: false,
    isVatReportSidebarCollapse: false,
    isNetaReportSidebarCollapse: false,
    isReceiptReceiveSidebarCollapse: false,
  },
  getters: {
    isShopSidebarCollapse: state => state.isShopSidebarCollapse,
    isProductSidebarCollapse: state => state.isProductSidebarCollapse,
    isServiceSidebarCollapse: state => state.isServiceSidebarCollapse,
    isUserSidebarCollapse: state => state.isUserSidebarCollapse,
    isSettingsSidebarCollapse: state => state.isSettingsSidebarCollapse,
    isNtaxUserSidebarCollapse: state => state.isNtaxUserSidebarCollapse,
    isStockTakingSidebarCollapse: state => state.isStockTakingSidebarCollapse,
    isDocketSidebarCollapse: state => state.isDocketSidebarCollapse,
    isVatReportSidebarCollapse: state => state.isVatReportSidebarCollapse,
    isNetaReportSidebarCollapse: state => state.isNetaReportSidebarCollapse,
    isReceiptReceiveSidebarCollapse: state => state.isReceiptReceiveSidebarCollapse,
  },
  mutations: {
    setIsShopSidebarCollapse(state, isShopSidebarCollapse) {
      state.isShopSidebarCollapse = isShopSidebarCollapse;
    },
    setIsProductSidebarCollapse(state, isProductSidebarCollapse) {
      state.isProductSidebarCollapse = isProductSidebarCollapse;
    },
    setIsServiceSidebarCollapse(state, isServiceSidebarCollapse) {
      state.isServiceSidebarCollapse = isServiceSidebarCollapse;
    },
    setIsUserSidebarCollapse(state, isUserSidebarCollapse) {
      state.isUserSidebarCollapse = isUserSidebarCollapse;
    },
    setIsSettingsSidebarCollapse(state, isSettingsSidebarCollapse) {
      state.isSettingsSidebarCollapse = isSettingsSidebarCollapse;
    },
    setIsNtaxUserSidebarCollapse(state, isNtaxUserSidebarCollapse) {
      state.isNtaxUserSidebarCollapse = isNtaxUserSidebarCollapse;
    },
    setIsStockTakingSidebarCollapse(state, isStockTakingSidebarCollapse) {
      state.isStockTakingSidebarCollapse = isStockTakingSidebarCollapse;
    },
    setIsDocketSidebarCollapse(state, isDocketSidebarCollapse) {
      state.isDocketSidebarCollapse = isDocketSidebarCollapse;
    },
    setIsVatReportSidebarCollapse(state, isVatReportSidebarCollapse) {
      state.isVatReportSidebarCollapse = isVatReportSidebarCollapse;
    },
    setIsNetaReportSidebarCollapse(state, isNetaReportSidebarCollapse) {
      state.isNetaReportSidebarCollapse = isNetaReportSidebarCollapse;
    },
    setIsReceiptReceiveSidebarCollapse(state, isReceiptReceiveSidebarCollapse) {
      state.isReceiptReceiveSidebarCollapse = isReceiptReceiveSidebarCollapse;
    },
  }
}
